var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      attrs: {
        disabled: _vm.disabled,
        color: _vm.buttonColor ? _vm.buttonColor : null,
        outline: _vm.depressed,
        depressed: _vm.depressed,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("onClicked")
        },
      },
    },
    [
      !_vm.isLoading
        ? [
            _vm.icon
              ? _c(
                  "v-icon",
                  { staticClass: "mr-2", attrs: { color: _vm.iconColor } },
                  [_vm._v(_vm._s(_vm.icon))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-none --text" }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
          ]
        : [_c("v-progress-circular", { attrs: { indeterminate: "" } })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }